import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {
  BrowserAnimationsModule,
  NoopAnimationsModule
} from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { TaskBarComponent } from './layout/mobile/task-bar/task-bar.component';
import { StoreModule } from '@ngrx/store';
import { userReducer } from './state/reducer/user.reducer';
import { LoginComponent } from './layout/components/login/login.component';
import { RegistrationComponent } from './layout/components/registration/registration.component';
import { RecoveryComponent } from './layout/components/recovery/recovery.component';
import localeSrLatn from '@angular/common/locales/sr-Latn';
import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './state/effects/user-authentification.effects';
import { SharedModule } from './shared/shared.module';
import { NotFoundComponent } from './layout/components/not-found/not-found.component';
import { MaintenanceComponent } from './layout/components/maintenance/maintenance.component';
import { VerificationComponent } from './layout/components/verification/verification.component';
import { RecoveryConfirmationComponent } from './layout/components/recovery-confirmation/recovery-confirmation.component';
import { PreloaderComponent } from './layout/components/preloader/preloader.component';
import { HeaderComponent } from './layout/mobile/header/header.component';
import { DefaultLayoutComponent } from './layout/default-layout.component';
import { buttonsReducer } from './state/reducer/buttons.reducer';

registerLocaleData(localeDe);
registerLocaleData(localeSrLatn);

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    DefaultLayoutComponent,
    HeaderComponent,
    TaskBarComponent,
    LoginComponent,
    RegistrationComponent,
    RecoveryComponent,
    NotFoundComponent,
    MaintenanceComponent,
    VerificationComponent,
    RecoveryConfirmationComponent,
    PreloaderComponent
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'de-DE' } // number formating 9.99,00
  ],
  bootstrap: [AppComponent],
  imports: [
    StoreModule.forRoot({ user: userReducer, buttons: buttonsReducer }),
    CommonModule,
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    NoopAnimationsModule,
    ReactiveFormsModule,
    StoreDevtoolsModule.instrument({
      name: 'NgRx Loyalty App Devtools',
      maxAge: 25,
      logOnly: environment.production
    }),
    EffectsModule.forRoot([AuthEffects])
  ]
})
export class AppModule {}
